// @flow

import bemify from 'bemify-js';
import React, { type Node } from 'react';

import 'app/login/components/LoginTitle.scss';

const bem = bemify('login-title');

const LoginTitle = ({ children }: { children: Node }) => (
  <h1 className={bem()}>{children}</h1>
);

export default LoginTitle;
